import { useCallback, useEffect, useState } from "react";
import Table from "../../common/Table";
import { useDispatch, useSelector } from "react-redux";
import { LuPencilLine } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { toast } from "react-toastify";
import ConfirmationPage from "../../common/ConfirmationPage";
import { deleteTrustedInstitute, getTrustedInstitutes } from "../../redux/services/trustedInstituteSlice";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant";

const TrustedBy = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getTrustedData = useSelector((state) => state?.trustedInstitute?.trustedByData);

  const [page, setPage] = useState(0);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);

  const getAllTrustedBy = useCallback(async () => {
    try {
      await dispatch(getTrustedInstitutes({ page: page + 1, limit: pageLimit, searchData }));
    } catch (error) {}
  }, [dispatch, page, pageLimit, searchData]);

  useEffect(() => {
    getAllTrustedBy();
  }, [getAllTrustedBy]);

  const deleteTrustedByData = async () => {
    try {
      const response = await dispatch(deleteTrustedInstitute(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllTrustedBy();
    } catch (error) {}
  };

  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    {
      header: "Image",
      key: "image",
      render: (value) =>
        value ? (
          <button className="max-w-16 max-h-16 overflow-hidden rounded-xl">
            <img src={value} alt="" className="w-full h-full" />
          </button>
        ) : (
          "—"
        ),
    },
    {
      header: "Link",
      key: "link",
      render: (link) => (
        <a href={link} target="_blank" rel="noreferrer" className="text-primary underline">
          Visit
        </a>
      ),
    },
  ];

  const actions = [
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: (row) => {
        navigate(`${ROUTES.WEBSITE.TRUSTED_BY_EDIT}?trustedId=${row._id}`, { state: { row } });
      },
    },
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
  ];

  return (
    <>
      <Table title="Trusted By" buttonTitle="Add Trusted By" showSearchbar={true} searchTerm={searchTerm} setSearchTerm={setSearchTerm} setSearchData={setSearchData} onAddClick={() => navigate(ROUTES.WEBSITE.TRUSTED_BY_ADD)} columns={columns} data={getTrustedData?.trusted_institute_data || []} actions={actions} pageCount={getTrustedData?.state?.page_limit} onPageChange={(selectedItem) => setPage(selectedItem.selected)} pageLimitOptions={limitOptions} selectedPageLimit={pageLimit} onPageLimitChange={setPageLimit} />
      {confirm && <ConfirmationPage topicName="Trusted Institute" confirm={confirm} onDelete={deleteTrustedByData} onCancel={() => setConfirm(false)} />}
    </>
  );
};

export default TrustedBy;
